import { useSyncExternalStore } from "react";

import { getCurrentEstablishment, subscribeEstablishment } from "./api";

/**
 * L'établissement choisi en haut du back-office, suivi en direct : l'écran se
 * redessine quand on en change, sans recharger la page. Le lire pendant le
 * rendu (`getCurrentEstablishment()`) ne suffit pas — React n'aurait aucune
 * raison de redessiner, et l'écran resterait sur l'ancien musée.
 */
export function useCurrentEstablishment(): string | null {
  return useSyncExternalStore(subscribeEstablishment, getCurrentEstablishment);
}
